import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import styled from 'styled-components';
import ListTable from '../../../../common/tables/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import {
  getColumns,
  getData,
  getEDIRFIDColumns,
  getEDIRFIDData,
  getIsLoading,
  getTotalColumns,
  getTotalData,
} from '../../../daily-route-leading-count-status/redux/selectors/DailyRouteLeadingCountStatusListSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import { DailyRouteLeadingCountStatusStyles } from '../../../daily-route-leading-count-status/containers/DailyRouteLeadingCountStatusListStyles';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';

const StyledComponentContainer = styled.div`${DailyRouteLeadingCountStatusStyles}`;
StyledComponentContainer.displayName = 'StyledComponentContainer';

class DailyRouteLeadingCountStatusDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.props.tableLoadData(
      { tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id },
      this.props.appContext.appContext,
      {
        impcFromList: [props.row.original.outboundImpc],
        impcToList: [props.row.original.inboundImpc],
        startDate: moment(props.row.original.startDate).format('YYYY-MM-DD'),
        endDate: moment(props.row.original.endDate).format('YYYY-MM-DD'),
      },
    );
  }

  render() {
    return (
      <div>
        <StyledComponentContainer>
          <div className="general-content-container" style={{ flexDirection: 'column' }}>
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                <ListTable
                  listId={TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id}
                  loading={this.props.isLoading}
                  columns={this.props.columns}
                  data={this.props.data}
                  keyField="id"
                  selectCheckbox
                  downloadType={downloadTypes.EXCEL}
                />
              </div>
            </div>
          </div>
        </StyledComponentContainer>
      </div>
    );
  }
}

DailyRouteLeadingCountStatusDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  isLoading: PropTypes.bool,
  row: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    dataTotal: getTotalData(state),
    columnsTotal: getTotalColumns(state),
    dataEDIRFID: getEDIRFIDData(state),
    columnsEDIRFID: getEDIRFIDColumns(state),
    appContext: getAssetType(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    isLoading: getIsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DailyRouteLeadingCountStatusDetailsContainer);
